import { render, staticRenderFns } from "./TextRowsStyle.vue?vue&type=template&id=27ddda6e&"
import script from "./TextRowsStyle.vue?vue&type=script&lang=js&"
export * from "./TextRowsStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports